var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusedNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c-.8 0-1.5.7-1.5 1.5v.7C7.3 4.9 5 7.6 5 11v4.5l-2 2.3V19h18v-1.2l-2-2.3V11c0-3.4-2.3-6.1-5.5-6.8v-.7c0-.8-.7-1.5-1.5-1.5zm-2 18c0 1.1.9 2 2 2s2-.9 2-2h-4z",
    fill: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusedNotifications);
export default __webpack_public_path__ + "static/media/FocusedNotifications.64cb979fba3c270354398b0361b42e44.svg";
export { ForwardRef as ReactComponent };